module.exports = __webpack_public_path__ + "img/intensive-cert-1920.d6b74902.jpg";